/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

const observer = new MutationObserver((mutations, observer) => {
    if (document.querySelector('.swym-notifications-container') && document.querySelector('.swym-simple-wishlist-modal')) {
        observer.disconnect(); // Stop observing once both elements are found
        setTimeout(() => {
            location.reload(); // Reload after 2 seconds
        }, 2000);
    }
});

// Observe changes in the body or another relevant container
observer.observe(document.body, { childList: true, subtree: true });

// --------------------------------------
const moveSwymInterval = setInterval(function() {
    const swymPlugin = document.querySelector('#swym-plugin');
    const actionList = document.querySelector('.header__action-list');
    
    if (swymPlugin && actionList) {
        // 1. Move it to the first location
        actionList.prepend(swymPlugin);
        
        // 2. Add your new class to the Swym element
        swymPlugin.classList.add('append-cls'); 
        
        // 3. Stop checking once it's moved
        clearInterval(moveSwymInterval); 
    }
}, 500); // Checks every half-second